module.exports = __webpack_public_path__ + "static/media/weight.19bfd3a8.png";